module.exports = __webpack_public_path__ + "img/20.89d2685b.png";